import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, ChevronDown, Menu } from "@opendate-app/setlist";
import axios from "axios";
import { toastError } from "../../../shared/toastHelper";

const AddOnPresetPicker = ({ teamId, onPick, size }) => {
  const [presets, setPresets] = useState([]);

  useEffect(() => {
    let ignore = false;
    Promise.resolve()
      .then(() => axios.get(`/teams/${teamId}/add_on_presets`))
      .then(({ data }) => { if (!ignore) setPresets(Array.isArray(data) ? data : []); })
      .catch((e) => {
        if (ignore) return;
        setPresets([]);
        if (e?.response && ![401, 403].includes(e.response.status)) toastError("Could not load add-on presets.");
      });
    return () => { ignore = true; };
  }, [teamId]);

  if (presets.length === 0) return null;

  return (
    <Menu
      placement="bottom-end"
      items={presets.map((preset) => ({ label: preset.name, onClick: () => onPick(preset.id) }))}
      trigger={(
        <Button variant="secondary" size={size} trailingIcon={ChevronDown} data-testid="add-on-preset-picker">
          Start from preset
        </Button>
      )}
    />
  );
};

AddOnPresetPicker.propTypes = {
  teamId: PropTypes.number.isRequired,
  onPick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["xs", "sm", "md"]),
};

AddOnPresetPicker.defaultProps = {
  size: "sm",
};

export default AddOnPresetPicker;
